// EWM-442 — hard ceiling for any quantity input (cart, PDP, quick order, etc.).
// Adjustable here in one place if the business raises/lowers the cap. Stock
// limits below this still apply; this is the absolute upper bound.
export const MAX_QUANTITY = 10000;
